import React from 'react';
import PortfolioUniversePage from './PortfolioUniversePage';

export default function HighReturnPage() {
  return (
    <PortfolioUniversePage
      strategyId="high-return"
      portfolioHoldingType="HIGH_RETURN"
    />
  );
}
